import React, { useMemo } from 'react'
import LinkLocale from '../../modules/i18n/LinkLocale'
import { s_content } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import Button from '../_legacy/Button'

/**
 * 앱 배너 다운로드 유도 위치
 * - 어느 페이지에서 해당 컴포넌트가 렌더가 되는지 분별용 enum
 */
export enum APP_DOWN_BANNER_LOCATION {
  LANDING_MENU, // 모바일 웹 메뉴 - 랜딩
  PORTAL_MENU, // 모바일 웹 메뉴 - 포털
}

enum APP_DOWN_BANNER_CLICK_LINK {
  PORTAL_MENU = 'https://ringle.page.link/qoWs',
  LANDING_MENU = 'https://ringle.page.link/X9NA',
}

// 모웹 앱 다운 유도 버튼 - 랜딩 배너

/**
 * 랜딩 페이지 스크롤 이벤트 세팅
 */
const LANDING_WITHOUT_LOGIN_ANIMATION_SETTINGS = {
  'data-aos': 'fade-up',
  'data-aos-offset': '-155',
  'data-aos-delay': '100',
  'data-aos-easing': 'ease-in-out',
  'data-aos-anchor': '#student-landing-tutor-card-title',
  'data-aos-anchor-placement': 'top-top',
}

type MobileAppDownBannerPropsType = {
  bannerLocation: APP_DOWN_BANNER_LOCATION
}

/**
 * 모바일 뷰에서 앱 유도 다운로드 배너
 */
const MobileAppDownBanner: React.FC<MobileAppDownBannerPropsType> = ({ bannerLocation }) => {
  const { t } = useTranslation()

  const appDownDynamicLink = useMemo(() => {
    switch (bannerLocation) {
      case APP_DOWN_BANNER_LOCATION.LANDING_MENU:
        return APP_DOWN_BANNER_CLICK_LINK.LANDING_MENU
      case APP_DOWN_BANNER_LOCATION.PORTAL_MENU:
        return APP_DOWN_BANNER_CLICK_LINK.PORTAL_MENU
    }
  }, [bannerLocation])

  return (
    <div className="bottom-[0px] w-full bg-white">
      <div className="flex items-center justify-between px-[20px] pb-[32px]">
        <div className="mr-[12px] flex h-[48px] w-[48px] items-center justify-center rounded-[10px] bg-purple-500">
          <img alt="logo" className="h-[29px] w-[38px]" src="/assets/img/logo/logo_white_transparent.png" />
        </div>
        <div className="text-h6 mr-[12px] flex-1 font-medium text-black">{t(s_content.mobile_web.access_on_app)}</div>
        <LinkLocale href={appDownDynamicLink} externalLink>
          <Button chipSm clx="!border-0 !text-h5 ! !bg-gray-300 !text-gray-700 font-medium p-8 whitespace-nowrap w-100">
            {t(s_content.mobile_web.view_in_app)}
          </Button>
        </LinkLocale>
      </div>
    </div>
  )
}

export default React.memo(MobileAppDownBanner)
